import { Money } from '../../../../types';

export const multiplyMoney = (money: Money, count: number): Money => ({
	...money,
	amount: money.amount * count
});
